module.exports = __webpack_public_path__ + "img/marker.2bfd9711.svg";